import React from 'react';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// v3 deprecated variants mapped to their v5 equivalents + original v3 styles (with custom theme overrides).
const v3Variants = {
    title: { variant: 'h6' },
    headline: { variant: 'h5' },
    display1: { variant: 'h4' },
    display2: { variant: 'h3' },
    display3: { variant: 'h2' },
    display4: { variant: 'h1' }
};

const StyledTypography = styled(MuiTypography)(({ theme, ownerState }) => ({
    ...(ownerState.v3Variant === 'title' && {
        fontSize: '1.1rem',
        fontWeight: 500,
        lineHeight: '1.17em'
    }),
    ...(ownerState.v3Variant === 'headline' && {
        fontSize: '1.5rem',
        fontWeight: 400,
        lineHeight: 1.35417
    }),
    ...(ownerState.v3Variant === 'display1' && {
        fontSize: '1.6rem',
        fontWeight: 400,
        lineHeight: 1.20588,
        color: 'rgba(0, 0, 0, 0.54)'
    }),
    ...(ownerState.v3Variant === 'display2' && {
        fontSize: '1.8rem',
        fontWeight: 400,
        lineHeight: 1.13333,
        color: 'rgba(0, 0, 0, 0.54)'
    }),
    ...(ownerState.v3Variant === 'display3' && {
        fontSize: '1.9rem',
        fontWeight: 500,
        lineHeight: 1.30357,
        letterSpacing: '-.02em',
        color: 'rgba(0, 0, 0, 0.54)'
    }),
    ...(ownerState.v3Variant === 'display4' && {
        fontSize: '2.25rem',
        fontWeight: 400,
        lineHeight: 1.14286,
        letterSpacing: '-.04em',
        color: 'rgba(0, 0, 0, 0.54)',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.65rem'
        }
    })
}));

const Typography = React.forwardRef(({ variant, ...props }, ref) => {
    const mapping = variant && v3Variants[variant];
    if (mapping) {
        return <StyledTypography ref={ref} variant={mapping.variant} ownerState={{ v3Variant: variant }} {...props} />;
    }
    return <MuiTypography ref={ref} variant={variant || 'body1'} {...props} />;
});

Typography.displayName = 'Typography';

export default Typography;
